
const MODAL_ATIVA = (state, payload) => {
  state.modal = payload
}

const MUDAR_SETOR_ATIVO = (state, payload) => {
  state.setorAtivo = payload.id
}

const TOGGLE_MENU = (state, payload) => {
  state.menu = payload
}

const ENVIAR_INFORMACOES_MODAL = (state, payload) => {
    state.infoModal = payload
    console.log(state.infoModal)
}


const ENVIAR_INFORMACOES_MODAL_BRASIL = (state, payload) => {
    state.infoModalBrasil = payload
}

const MOSTRAR_VIDEO = (state, payload) => {
    state.modalVideo = payload
}




export default {
  MODAL_ATIVA,
  MUDAR_SETOR_ATIVO,
  TOGGLE_MENU,
  ENVIAR_INFORMACOES_MODAL,
  MOSTRAR_VIDEO,
  ENVIAR_INFORMACOES_MODAL_BRASIL
}
